<template>
    <div class="tfooter flex center vcenter">
        <div class="pagination flex wrap center vcenter">
            <template v-for="(page, index) in paginations" :key="index">
                <div class="flex wrap center vcenter"
                    :class="[{ 'active': Number((this.$route.params.page || this.page)) === page }]"
                    @click.prevent="navigate(page)">
                    <p>{{ page }}</p>
                </div>
            </template>
        </div>
        <div v-if="count" class="count">
            <p>نتایج کشف شده: {{ count }}</p>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'TFooter',
    props: ['entity_type', 'page', 'size', 'count', 'update'],
    data() {
        return {
            pages: 0,
            paginations: []
        }
    },
    watch: {
        entity_type(newEntity, oldEntity) {
            this.init()
        },
        $route(from, to) {
            this.init()
        },
        count(newCount, oldCount) {
            this.init()
        },
        update(newUpdate, oldUpdate) {
            this.init()
        }
    },
    methods: {
        init() {
            this.pages = 0
            this.paginations = []

            this.pages = Math.ceil(this.count / Number(this.size))
            if (this.pages >= (this.$route.params.page || this.page)) {
                if (this.pages > 3 && (this.$route.params.page || this.page) > 1)
                    this.paginations.push('<<')
                if ((this.$route.params.page || this.page) > 1)
                    this.paginations.push('<')
                if ((this.$route.params.page || this.page) >= 3)
                    this.paginations.push(Number((this.$route.params.page || this.page)) - 2)
                if ((this.$route.params.page || this.page) >= 2)
                    this.paginations.push(Number((this.$route.params.page || this.page)) - 1)
                this.paginations.push(Number((this.$route.params.page || this.page)))
                if (this.pages >= Number((this.$route.params.page || this.page)) + 1)
                    this.paginations.push(Number((this.$route.params.page || this.page)) + 1)
                if (this.pages >= Number((this.$route.params.page || this.page)) + 2)
                    this.paginations.push(Number((this.$route.params.page || this.page)) + 2)
                if ((this.$route.params.page || this.page) < this.pages) {
                    this.paginations.push('>')
                    if (this.pages > 3)
                        this.paginations.push('>>')
                }
            }
        },
        navigate(destination) {
            this.$router.push({
                path: window.location.pathname.replace(`/${(this.$route.params.page || this.page)}/${this.size}`
                    , `/${destination === '<<' ? 1 : destination === '>'
                        ? Number((this.$route.params.page || this.page)) + 1 : destination === '<'
                            ? Number((this.$route.params.page || this.page)) - 1 : destination === '>>'
                                ? this.pages : destination}/${this.size}`), query: this.$route.query
            })
        }
    }
}
</script>